import Axios from '../lib/axios';

const LoginCheck = () => {
  return Axios.get(process.env.REACT_APP_SERVER_ROOT + '/login_check');
};

const GetRedirectingRoutes = () => {
  return Axios.get(process.env.REACT_APP_SERVER_ROOT + '/redirect-routes');
};

const LogOut = () => {
  return Axios.post(process.env.REACT_APP_SERVER_ROOT + '/logout');
};

const Impersonate = (targetUserId) => {
  return Axios.post(process.env.REACT_APP_SERVER_ROOT + '/impersonate', { targetUserId });
};

const StopImpersonate = () => {
  return Axios.post(process.env.REACT_APP_SERVER_ROOT + '/stop-impersonation');
};

const GetImpersonationStatus = () => {
  return Axios.get(process.env.REACT_APP_SERVER_ROOT + '/impersonation-status');
};

const GetManagers = () => {
  return Axios.get(process.env.REACT_APP_SERVER_ROOT + '/user/managers');
};

const GetManagedUsers = () => {
  return Axios.get(process.env.REACT_APP_SERVER_ROOT + '/user/managedUsers');
};

const AuthService = {
  LoginCheck,
  LogOut,
  Impersonate,
  StopImpersonate,
  GetImpersonationStatus,
  GetRedirectingRoutes,
  GetManagers,
  GetManagedUsers,
};

export default AuthService;
